<template>
  <header>
    <div class="header-wrapper">
      <div class="header-flex">
        <router-link tag="div" :to="{path: '/'}" class="img-wrap">
          <img src="./../assets/sandbox-logo.png" alt="Sandbox Group">
        </router-link>
        <router-link class="admin-button" v-if="isAdmin()" tag="button" :to="{path: '/admin/generate-codes'}">
          Admin
        </router-link>
        <button v-if="this.loggedIn()" @click="logout()">Omat tiedot</button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Header',
  computed: {
    ...mapGetters('Auth', ['sessionValid', 'loggedIn', 'isAdmin']),
  },
  methods: {
    logout () {
      this.$router.push('/user');
    },
    ...mapActions('Auth', ['authLogout']),
  },
}
</script>

<style lang="scss" scoped>

@import 'src/color.scss';
@import 'src/values.scss';

  .header-wrapper {
    max-width: 600px;
    margin: 0 auto;
    padding: 1em 0.25em;
    box-sizing: border-box;
  }

  .header-flex {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  header {
    padding: 0;
    // padding-bottom: 1em;
    background: $primary;
  }

  h1 {
    margin: 0;
  }

  img {
    width: 100%;
  }

  .img-wrap {
    cursor: pointer;
    width: 25%;
    max-width: 5em;
    align-self: flex-start;
  }

  button {
    align-self: flex-start;
  }

  button {
    padding: 0.3em 0.5em;
    //border-radius: 0.5em;
    //background: linear-gradient($secondary-light, $secondary);
    background: $secondary;
    color: $secondary-text;
    border: 1px solid $secondary-dark;
    font-weight: bold;
    cursor: pointer;

    transition: $transition-time all;
    &:hover {
      background-color: $secondary-dark;
    }
  }

  .admin-button {
    margin-left: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue